import {Text as TextExtension} from "@tiptap/extension-text";

export default class Text {

    constructor() {

    }

    static create() {
        return new Text();
    }

    getExtensions() {
        return [TextExtension];
    }
}